export default __webpack_public_path__ + "static/media/arm_swing_c.9f00a0cc.png";